export const defaultImage = '/assets/default.png';

export const secretStorageKey = 'rift-secret';
export const apiBindings: {api: string, images: string} = {
    api: "https://riftadminfunctions-dev.azurewebsites.net/api/",
    images: "https://riftadminfunctionsdev.blob.core.windows.net/image-bindings/"
}